import React from 'react';

import { Range, getTrackBackground } from 'react-range';

export default function Basic({ step = 1, min = 0, max = 100, values, setValues = null, rtl = false, ...props }) {
    return (
        <div className="tw-flex tw-items-center tw-gap-x-2 tw-w-full">
            <p className="tw-text-blue-500 tw-font-semibold">{values[0]}%</p>
            <div className="tw-w-full">
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        flexWrap: 'wrap',
                    }}
                >
                    <Range
                        {...props}
                        values={values}
                        step={step}
                        min={min}
                        max={max}
                        rtl={rtl}
                        onChange={(values) => setValues(values)}
                        renderTrack={({ props, children }) => (
                            <div
                                onMouseDown={props.onMouseDown}
                                onTouchStart={props.onTouchStart}
                                style={{
                                    ...props.style,
                                    height: '36px',
                                    display: 'flex',
                                    width: '100%',
                                }}
                            >
                                <div
                                    ref={props.ref}
                                    style={{
                                        height: '5px',
                                        width: '100%',
                                        borderRadius: '4px',
                                        background: getTrackBackground({
                                            values,
                                            colors: ['#548BF4', '#ccc'],
                                            min: min,
                                            max: max,
                                            rtl,
                                        }),
                                        alignSelf: 'center',
                                    }}
                                >
                                    {children}
                                </div>
                            </div>
                        )}
                        renderThumb={({ props, isDragged }) => (
                            <div
                                {...props}
                                key={props.key}
                                style={{
                                    ...props.style,
                                    height: '16px',
                                    width: '16px',
                                    borderRadius: '4px',
                                    backgroundColor: '#FFF',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    boxShadow: '0px 2px 6px #AAA',
                                }}
                            >
                                <div
                                    style={{
                                        height: '8px',
                                        width: '5px',
                                        backgroundColor: isDragged ? '#548BF4' : '#CCC',
                                    }}
                                />
                            </div>
                        )}
                    />
                </div>
            </div>
        </div>
    );
}
